module.exports = __webpack_public_path__ + "static/media/instagram.333d8cf8.png";